import { render, staticRenderFns } from "./FeedbackVideo.vue?vue&type=template&id=57ffcd90"
import script from "./FeedbackVideo.vue?vue&type=script&lang=ts"
export * from "./FeedbackVideo.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackVideo.vue?vue&type=style&index=0&id=57ffcd90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports